import api from '../api';

/**
* Actions для раздела "Мои дети" - сумма затрат ребенка в день
*/

export const CAFETERIA_COSTS_REQUEST = 'CAFETERIA_COSTS_REQUEST';
export const CAFETERIA_COSTS_SUCCESS = 'CAFETERIA_COSTS_SUCCESS';
export const CAFETERIA_COSTS_FAIL = 'CAFETERIA_COSTS_FAIL';

const failedCafeteriaCosts = err => ({
  type: CAFETERIA_COSTS_FAIL,
  payload: { err },
});

const receiveCafeteriaCosts = data => ({
  type: CAFETERIA_COSTS_SUCCESS,
  payload: data,
});

const requestCafeteriaCosts = () => ({
  type: CAFETERIA_COSTS_REQUEST,
});

/**
/* Получение данных о затратах ребенка в столовой за день
*/
export function fetchCosts(date) {
  return async (dispatch) => {
    try {
      dispatch(requestCafeteriaCosts());
      const response = await api('cabinet/cafeteria/costs', 'get', { params: { date } });
      dispatch(receiveCafeteriaCosts(response.data));
    } catch (error) {
      dispatch(failedCafeteriaCosts('Не удалось получить данные о затратах в столовой ребенка/детей'));
    }
  };
}
